import {useEffect, useState} from 'react';
import {finalizeHarvest, getPlantsByStage, getPlantTrim} from "../../api/Api";
import {BULK_COST_PRECISION, PlantStageType} from "../../api/Constants";
import {HarvestedPlantCard} from "./HarvestedPlantCard";
import {Card, Button, Row, Col, InputNumber, message} from 'antd';
import {HarvestedTotalCard} from "./HarvestedTotalCard";
import {BatchSelectWidget} from "../inventory/BatchSelectWidget";
import {handleNoSession} from "../../util/errorUtils";

export const HarvestedPlants = ({session, room, refresh, onRefresh, onApiFail, props}) => {
    const [plants, setPlants] = useState([]);
    const [trim, setTrim] = useState({});
    const [batch, setBatch] = useState(undefined);

    const [cost, setCost] = useState(0);
    const [finalizeStatus, setFinalizeStatus] = useState(undefined);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (room === undefined) {
            return;
        }

        const {id: roomId} = room;
        getPlantsByStage(roomId, PlantStageType.Trim).then(r => {
            setPlants(r.map(row => {
                return {
                    ...row,
                    key: row.id
                }
            }));

            const promises = [];
            r.forEach(row => {
                promises.push(getPlantTrim(row.id))
            });

            return Promise.all(promises);
        }).then(r => {
            const nextTrim = {};
            r.forEach(plantTrim => {
                plantTrim.forEach(product => {
                    const {productId,  amount} = product;
                    if (nextTrim[productId] !== undefined) {
                        nextTrim[productId].amount += amount;
                    } else {
                        nextTrim[productId] = {...product, key: product.productId};
                    }
                })
            });
            setTrim(nextTrim);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });

    }, [room, refresh, onApiFail]);

    const onBatchSelect = (batch) => {
        setBatch(batch);
    }

    const onCostChange = (val) => {
        setCost(val);
    }

    const clearForm = () => {
        setCost(0);
        setBatch(undefined);
    }

    const onFinalize = async () => {
        const {id: roomId} = room;
        setFinalizeStatus({message: 'Finalize In-Progress', color: '#108ee9'});

        finalizeHarvest(roomId, batch.id, cost).then(r => {
            console.log('finalize done');
            clearForm();
            setFinalizeStatus({message: 'Completed', color: 'green'});
            messageApi.open({
                type: 'success',
                content: 'Finalize Completed'
            });
            if (onRefresh) onRefresh();
        }).catch(e => {
            handleNoSession(e, onApiFail);
            setFinalizeStatus({message: 'Finalize Failed', color: 'red'});
            messageApi.open({
                type: 'error',
                content: 'Finalize Failed'
            });
        });
    }

    if (room  === undefined) {
        return <div/>
    }

    const cardStyle={
        textAlign: 'left',
        marginTop: '10px',
        marginBottom: '10px',
    }

    const rowStyle={
        marginTop: '10px',
        marginBottom: '10px'
    }

    let batchWarning = false;
    if (batch !== undefined) {
        // walk through all the plants and check to make sure the batch matches the selected batch
        plants.forEach(plant => {
            if (plant.batchId !== batch.id) {
                batchWarning = true;
            }
        });
    }

    return <div>
        {contextHolder}
        {
            plants.map(p => {
                return <HarvestedPlantCard plant={p} key={p.id} session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
            })
        }
        <HarvestedTotalCard trim={trim} batch={batch} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        <div style={{marginTop: '10px', marginBottom: '10px'}}>
            <BatchSelectWidget selectedBatch={batch} onSelect={onBatchSelect} refresh={refresh}  onApiFail={onApiFail} />
        </div>
        { (batch !== undefined) &&
            <Card title={<b>Finalize</b>} style={cardStyle}>
                {(batchWarning) &&
                    <Row style={{...rowStyle, color: 'red'}}>
                        <b>WARNING: Not all Plants Match the Selected Batch.   Are you sure you want to proceed?</b>
                    </Row>
                }
                <Row style={rowStyle}>
                    <Col span={2} style={{marginTop: '5px'}}>
                        <b>Cost ($ per g):</b>
                    </Col>
                    <Col>
                        <InputNumber style={{width:200}} value={cost} onChange={onCostChange} min={0} precision={BULK_COST_PRECISION} />
                    </Col>
                </Row>
                <Button onClick={onFinalize} disabled={finalizeStatus !== undefined}>Finalize</Button>
                {(finalizeStatus !== undefined) &&
                <Row style={rowStyle}>
                    <div style={{color: finalizeStatus.color}}>{finalizeStatus.message}</div>
                </Row>
                }
            </Card>
        }
    </div>
}